let mapStyles = {
	styles: [
		{
			'featureType': 'all',
			'elementType': 'all',
			'stylers': [
				{
					'color': '#f5f5f6'
				}
			]
		},
		{
			'featureType': 'all',
			'elementType': 'labels.text.fill',
			'stylers': [
				{
					'visibility': 'on'
				},
				{
					'color': '#ff0000'
				}
			]
		},
		{
			'featureType': 'all',
			'elementType': 'labels.text.stroke',
			'stylers': [
				{
					'visibility': 'on'
				},
				{
					'weight': '2.75'
				}
			]
		},
		{
			'featureType': 'administrative',
			'elementType': 'labels.text.fill',
			'stylers': [
				{
					'color': '#334455'
				},
				{
					'visibility': 'on'
				}
			]
		},
		{
			'featureType': 'administrative.country',
			'elementType': 'geometry.stroke',
			'stylers': [
				{
					'color': '#334455'
				},
				{
					'saturation': '0'
				},
				{
					'lightness': '50'
				},
				{
					'gamma': '1'
				}
			]
		},
		{
			'featureType': 'administrative.country',
			'elementType': 'labels',
			'stylers': [
				{
					'visibility': 'off'
				}
			]
		},
		{
			'featureType': 'landscape',
			'elementType': 'all',
			'stylers': [
				{
					'hue': '#0080ff'
				}
			]
		},
		{
			'featureType': 'landscape.natural.terrain',
			'elementType': 'all',
			'stylers': [
				{
					'visibility': 'on'
				},
				{
					'color': '#334455'
				},
				{
					'saturation': '0'
				},
				{
					'lightness': '85'
				},
				{
					'gamma': '1.00'
				}
			]
		},
		{
			'featureType': 'poi',
			'elementType': 'all',
			'stylers': [
				{
					'visibility': 'off'
				}
			]
		},
		{
			'featureType': 'poi.park',
			'elementType': 'geometry.fill',
			'stylers': [
				{
					'visibility': 'on'
				},
				{
					'color': '#334455'
				},
				{
					'lightness': '90'
				}
			]
		},
		{
			'featureType': 'poi.park',
			'elementType': 'geometry.stroke',
			'stylers': [
				{
					'visibility': 'off'
				}
			]
		},
		{
			'featureType': 'road',
			'elementType': 'all',
			'stylers': [
				{
					'saturation': -100
				},
				{
					'lightness': '50'
				}
			]
		},
		{
			'featureType': 'road.highway',
			'elementType': 'all',
			'stylers': [
				{
					'visibility': 'simplified'
				}
			]
		},
		{
			'featureType': 'road.highway',
			'elementType': 'geometry.fill',
			'stylers': [
				{
					'visibility': 'on'
				}
			]
		},
		{
			'featureType': 'road.highway',
			'elementType': 'geometry.stroke',
			'stylers': [
				{
					'visibility': 'on'
				},
				{
					'color': '#334455'
				},
				{
					'lightness': '80'
				},
				{
					'gamma': '1.00'
				}
			]
		},
		{
			'featureType': 'road.highway',
			'elementType': 'labels',
			'stylers': [
				{
					'visibility': 'off'
				}
			]
		},
		{
			'featureType': 'road.arterial',
			'elementType': 'geometry.fill',
			'stylers': [
				{
					'visibility': 'on'
				},
				{
					'color': '#334455'
				},
				{
					'lightness': '80'
				},
				{
					'gamma': '1.00'
				}
			]
		},
		{
			'featureType': 'road.arterial',
			'elementType': 'labels.text.fill',
			'stylers': [
				{
					'color': '#334455'
				}
			]
		},
		{
			'featureType': 'road.arterial',
			'elementType': 'labels.icon',
			'stylers': [
				{
					'visibility': 'off'
				}
			]
		},
		{
			'featureType': 'road.local',
			'elementType': 'geometry.fill',
			'stylers': [
				{
					'visibility': 'on'
				},
				{
					'color': '#334455'
				},
				{
					'lightness': '90'
				},
				{
					'gamma': '1.00'
				}
			]
		},
		{
			'featureType': 'road.local',
			'elementType': 'geometry.stroke',
			'stylers': [
				{
					'visibility': 'on'
				}
			]
		},
		{
			'featureType': 'road.local',
			'elementType': 'labels.text.fill',
			'stylers': [
				{
					'visibility': 'on'
				},
				{
					'color': '#99a1aa'
				}
			]
		},
		{
			'featureType': 'transit',
			'elementType': 'all',
			'stylers': [
				{
					'visibility': 'off'
				}
			]
		},
		{
			'featureType': 'water',
			'elementType': 'all',
			'stylers': [
				{
					'color': '#0088ee'
				},
				{
					'visibility': 'on'
				},
				{
					'lightness': '50'
				},
				{
					'gamma': '1'
				}
			]
		}
	]
}

export default mapStyles